
(function systemTranslateFilterModuleDefinition() {

    'use strict';

    angular.module('SystemTranslateFilter', ['pascalprecht.translate'])
        .filter('systemTranslate', ['$filter', function systemTranslateFilterFactory($filter) {
            /*
            Filtro de traducción solo para textos que comienzan con #
            */
            var translateFilter = $filter('translate');

            var sysTranslateFilter = function (translationId, interpolateParams, interpolation) {
                if (translationId.length && translationId.charAt(0) === '#') {
                    return translateFilter(translationId.substring(1), interpolateParams, interpolation);
                }

                return translationId;
            };

            return sysTranslateFilter;
        }]);

    angular.module('SystemTranslateFilter')
        .filter('typeTranslate', ['$filter', '$translate', function ($filter, $translate) {
            return function (metadata, mask) {
                if (metadata && metadata.type) {
                    switch (metadata.type) {
                        case 'date':
                            metadata.value = $filter('date')(metadata.value, mask || "dd/MM/yyyy");
                            break;
                        case 'bool':
                            if (metadata.value == true || metadata.value == false) {
                                $translate(['Yes', 'No']).then(function (translation) {
                                    metadata.value = metadata.value ? translation.Yes : translation.No;
                                });
                            }

                            break;
                        case 'combo':
                            metadata.value = metadata.description;
                            break;
                        default:
                    }
                }

                return metadata.value;
            };
        }]);
})();